module.exports = __webpack_public_path__ + "static/scale-model-of-san-antonio-explorer-pass®-in-san-antonio-texas-bb5a06305b5e0771f78a40afcb9f7389.png";